import { render, staticRenderFns } from "./CustomersSearch.vue?vue&type=template&id=4646e1d6&scoped=true&"
import script from "./CustomersSearch.vue?vue&type=script&lang=js&"
export * from "./CustomersSearch.vue?vue&type=script&lang=js&"
import style1 from "./CustomersSearch.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4646e1d6",
  null
  
)

export default component.exports